import React from 'react'

export const CoreContext = React.createContext( {
  openModal: () => {},
  toast: () => {},
  changeLanguage: () => {}
} )

CoreContext.displayName = 'Core'


// WEBPACK FOOTER //
// ./src/contexts/core.js